import { Outlet } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';
import GlitchyCheckerboard from './GlitchyCheckerboard';

/**
 * Main layout component that provides the structure for all pages
 * 
 * Features:
 * - Animated glitchy checkerboard background with scanlines overlay
 * - Responsive header, main content area, and footer
 * - Proper z-index layering for background and content
 * - Dark theme with overflow hidden for full-screen background
 * 
 * @returns JSX element containing the complete page layout structure
 */
function Layout() {
  return (
    <div className="relative min-h-screen flex flex-col bg-black text-gray-200 overflow-hidden">
      <GlitchyCheckerboard />
      <div className="relative z-10 min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default Layout;
